import { render, staticRenderFns } from "./PlaylistAdmin.vue?vue&type=template&id=28019cb8"
import script from "./PlaylistAdmin.vue?vue&type=script&lang=js"
export * from "./PlaylistAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports